import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CheckoutStockService {
  private pendingProducts: any[] | null = null;

  setPendingProducts(products: any[]): void {
    this.pendingProducts = products;
  }

  consumePendingProducts(): any[] | null {
    const products = this.pendingProducts;
    this.pendingProducts = null;
    return products;
  }
}
